export default "__VITE_ASSET__CS3smTl8__"